export const CONTESTS = "CONTESTS";
export const SET_VOTE_POST = "SET_VOTE_POST";
export const SEARCH_CONTESTS = "SEARCH_CONTESTS";